import { SystemConfiguration } from './system-configuration';
import { ScheduleType } from '../dtos/customer.dto';

export function isScheduledSource(scheduleType?: ScheduleType): boolean {
    return scheduleType === 'SCHEDULED_SOURCE';
}

export function isScheduledTarget(scheduleType?: ScheduleType): boolean {
    return scheduleType === 'SCHEDULED_TARGET';
}

export function isScheduledVersionUpcoming(scheduledDate?: Date): boolean {
    if (!scheduledDate) return false;

    const now = new Date();
    const timeBeforeSchedule = SystemConfiguration.getInstance().editApplyPolicyTimeBeforeSchedule * 60 * 1000;
    return (new Date(scheduledDate).getTime() - now.getTime()) <= timeBeforeSchedule;
}
